import React, { useEffect } from 'react';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  isProtected = false, // <-- new prop
  ...props
}) => {
  const dispatch = useDispatch();
  const permissions = useSelector(
    (state) => state.auth.user?.role?.permissions || []
  );

  useEffect(() => {
    const isBlank = blankLayout ? true : false;
    dispatch(onBlankLayout(isBlank));
  }, [blankLayout]);

  // Only check permissions for protected routes
  if (
    isProtected &&
    routeKey !== 'not-authorized' &&
    !(permissions.includes('*') || (routeKey && permissions.includes(routeKey)))
  ) {
    return <Navigate to="/app/not-authorized" replace />;
  }

  return <Component {...props} routeKey={routeKey} />;
};

export default AppRoute;
